import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import UserService from '../../services/userServices';
import { clearAuth } from 'store/auth';
import { isObject } from 'lodash';

export const getList = createAsyncThunk('user/list', async ({ status, page, perPage, sort, orderBy, search }, thunkAPI) => {
  try {
    const response = await UserService.getList(status, page, perPage, sort, orderBy, search);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('user/create', async (data, thunkAPI) => {
  try {
    const response = await UserService.create(data);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('user/read', async (id, thunkAPI) => {
  try {
    const response = await UserService.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('user/update', async (data, thunkAPI) => {
  try {
    const response = await UserService.update(data.id, data);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('user/delete', async (id, thunkAPI) => {
  try {
    const response = await UserService.del(id);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    if (error.response.status == 404) {
      thunkAPI.dispatch(getList());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getGuru = createAsyncThunk('user/getGuru', async (_, thunkAPI) => {
  try {
    const response = await UserService.getGuru();
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateMapels = createAsyncThunk('user/updateMapels', async ({ id, data }, thunkAPI) => {
  try {
    const response = await UserService.updateMapels(id, data);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const addMapel = createAsyncThunk('user/addMapel', async ({ id, mapelID }, thunkAPI) => {
  try {
    const response = await UserService.addMapel(id, mapelID);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const delMapel = createAsyncThunk('user/delMapel', async ({ id, mapelID }, thunkAPI) => {
  try {
    const response = await UserService.delMapel(id, mapelID);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateJenjangs = createAsyncThunk('user/updateJenjangs', async ({ id, data }, thunkAPI) => {
  try {
    const response = await UserService.updateJenjangs(id, data);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const addJenjang = createAsyncThunk('user/addJenjang', async ({ id, jenjangID }, thunkAPI) => {
  try {
    const response = await UserService.addJenjang(id, jenjangID);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const delJenjang = createAsyncThunk('user/delJenjang', async ({ id, jenjangID }, thunkAPI) => {
  try {
    const response = await UserService.delJenjang(id, jenjangID);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changeStatus = createAsyncThunk('user/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await UserService.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updatePhoto = createAsyncThunk('user/updatePhoto', async ({ id, photo }, thunkAPI) => {
  try {
    const response = await UserService.updatePhoto(id, photo);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deletePhoto = createAsyncThunk('user/deletePhoto', async (id, thunkAPI) => {
  try {
    const response = await UserService.deletePhoto(id);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const addRole = createAsyncThunk('user/addRole', async ({ id, roleID }, thunkAPI) => {
  try {
    const response = await UserService.addRole(id, roleID);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const delRole = createAsyncThunk('user/delRole', async ({ id, roleID }, thunkAPI) => {
  try {
    const response = await UserService.delRole(id, roleID);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changePassword = createAsyncThunk('user/changePassword', async ({ id, data }, thunkAPI) => {
  try {
    const response = await UserService.changePassword(id, data);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

const initialState = { isLoading: false, list: [], guru: [], data: [], error: [] };

const userSlice = createSlice({
  name: 'user',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = isObject(action.payload.errors) ? action.payload.errors : [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = isObject(action.payload.errors) ? action.payload.errors : [];
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateJenjangs.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateJenjangs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(updateJenjangs.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addJenjang.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addJenjang.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(addJenjang.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(delJenjang.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(delJenjang.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(delJenjang.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateMapels.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateMapels.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(updateMapels.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addMapel.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addMapel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(addMapel.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(delMapel.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(delMapel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(delMapel.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getGuru.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getGuru.fulfilled, (state, action) => {
        state.isLoading = false;
        state.guru = action.payload;
      }),
      builder.addCase(getGuru.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updatePhoto.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updatePhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(updatePhoto.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deletePhoto.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deletePhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(deletePhoto.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addRole.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addRole.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(addRole.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(delRole.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(delRole.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(delRole.rejected, (state) => {
        state.isLoading = false;
      });
    builder.addCase(changePassword.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(changePassword.fulfilled, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = userSlice;
export default reducer;
